/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Row, Col } from 'antd';

const TableHeader = ({ children, style, gutter = 10, gutterX = gutter, gutterY = gutter, as: Component = 'div' }) => (
  <Component style={{ padding: `0px 0px ${gutterY * 2}px ${gutterX / 2}px`, ...style }}>
    <Row gutter={gutter} align="middle">
      {children}
    </Row>
  </Component>
);

const TableHeaderItem = (props) => <Col {...props} />;

const BORDER_WIDTH = 1;
const TableHeaderCheckboxItem = ({ style, gutter = 20, ...props }) => (
  <Col flex="0 0 65px" {...props} style={{ padding: `0 ${gutter}px 0 ${gutter + BORDER_WIDTH}px`, ...style }} />
);

TableHeader.Item = TableHeaderItem;
TableHeader.CheckBox = TableHeaderCheckboxItem;

export default TableHeader;
